import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import classNames from 'classnames';
import nds from '@nerdwallet/base-styles/classes';

import { Text, Box } from '@nerdwallet/currency';
import Image from '../image/image';

import { getTypedValue } from '../../lib/helpers';

import { dataDependencyNumericIdInput } from '../../lib/editing-configs';
import parseMdlinks from '../../lib/parse-md-links';

import './award-table.less';

const AwardTableSection = ({
  offer,
  highlight,
  title,
  image,
  imageAlt,
  linkUrl,
  cardLinkText,
  subtitle,
  removeMargins,
}) => {
  const slug = getTypedValue(offer, 'details.slug');

  const imgSrc = getTypedValue(offer, 'details.image_source');
  const prodName = get(offer, 'product.name');
  const hasOfferImg = imgSrc && imgSrc !== '';
  const hasStaticImg = image && image !== '';
  const displayOffer = hasOfferImg ? (
    <a href={`/card-details/card-name/${slug}`}>
      <Image src={imgSrc} className="award-table__image" />
    </a>
  ) : null;
  const displayStatic = hasStaticImg ? (
    <a href={linkUrl}>
      <Image src={image} alt={imageAlt} className="award-table__image" />
    </a>
  ) : null;
  const displayReviewLink = (
    <div>
      <Box className="award-table__subtitle">
        <Text size="small">
          {/* eslint-disable-next-line react/no-danger -- directive added automatically by Shepherd migration */}
          <span dangerouslySetInnerHTML={{ __html: prodName }} />
        </Text>
      </Box>
      <a href={`/card-details/card-name/${slug}`}>
        <Box className={[nds('margin-top-2')]}>
          <Text size="small">{cardLinkText}</Text>
        </Box>
      </a>
    </div>
  );
  const displayStaticSubtitle = (
    <Box className="award-table__subtitle">
      <Text size="small">{parseMdlinks(subtitle)}</Text>
    </Box>
  );

  return (
    <div
      className={classNames('award-table__container', {
        [nds('margin-bottom-4')]: !removeMargins,
        [nds('margin-bottom-2')]: removeMargins,
      })}
    >
      {offer ? displayOffer : displayStatic}
      <div className="award-table__content">
        {highlight && (
          <div className="award-table__highlight-cont">
            <Box className="award-table__highlight">
              <Text bold size="small">
                {highlight}
              </Text>
            </Box>
          </div>
        )}
        <Box className="award-table__title">
          <Text size="large" bold component="h5">
            {title}
          </Text>
        </Box>
        {offer ? displayReviewLink : displayStaticSubtitle}
      </div>
    </div>
  );
};

AwardTableSection.propTypes = {
  offer: PropTypes.object,
  highlight: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  linkUrl: PropTypes.string,
  cardLinkText: PropTypes.string,
  subtitle: PropTypes.string,
  removeMargins: PropTypes.bool,
};

AwardTableSection.getEditingConfig = () => [dataDependencyNumericIdInput];

AwardTableSection.defaultProps = {
  cardLinkText: 'Get card details >',
  removeMargins: false,
};

AwardTableSection.displayName = 'AwardTableSection';

export default AwardTableSection;
